
export default {
  name: 'var-list',
  props: {
    value: { type: Boolean, default: false }
  },
  data: function () {
    return {
      items: [
        '人数',
        '日数',
        '収入額',
        '宿泊税',
        'A総売上',
        'Bサイト手数料',
        'C弊社報酬',
        'D清掃費',
        'Eアメニティ',
        'F消耗品',
        'Gクリーニング',
        'Hウエルカムシャンパン'
      ]
    };
  },
  computed: {
    opened: function () {
      return this.value;
    }
  },
  methods: {
    close: function () {
      this.$emit('input', false);
    },
    pick: function (label) {
      this.$emit('pick', label);
      this.close();
    }
  }
};
